export default "__VITE_ASSET__BnJ0JxON__"